import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography } from '@metarouter-private/mr-mui';

import { AceCodeEditor } from '@ion/components';
import CopyToClipboard from 'app/components/CopyToClipboard';
import DebuggerDrawerNavigation from 'app/event-monitoring/event-debugger/event-debugger-table/DebuggerDrawer/DebuggerDrawerNavigation';

const SECTION_TITLE = 'Request Headers';
const EMPTY_MESSAGE = 'No request data for this row.';

export default function RequestHeaders({ value }) {
  const displayValue = value || EMPTY_MESSAGE;

  return (
    <Stack spacing={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={2} alignItems="center">
          <DebuggerDrawerNavigation />
          <Typography variant="h6">{SECTION_TITLE}</Typography>
        </Stack>

        <CopyToClipboard text={displayValue} />
      </Stack>

      <AceCodeEditor rows={30} name="request-drawer-headers" readOnly lang="text" value={displayValue} />
    </Stack>
  );
}

RequestHeaders.propTypes = {
  value: PropTypes.string.isRequired,
};
